// extracted by mini-css-extract-plugin
module.exports = {"loader":"_index-loader-2Dzv","loaderLabel":"_index-loader-label-zhna"};